import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { nuevaDuracion } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-detail';
import { MinuteRequestService } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/service/minute-request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-update-duration-minute',
  templateUrl: './modal-update-duration-minute.component.html',
  styleUrls: ['./modal-update-duration-minute.component.scss']
})
export class ModalUpdateDurationMinuteComponent {
  public request: nuevaDuracion = {minuteRequestId:0, newDateDuration:null};
  public fecha1: Date;
  public fecha: Date = new Date();

  constructor( @Inject(MAT_DIALOG_DATA)public data: nuevaDuracion, private serviceMinuta: MinuteRequestService ) {
  }

  ngOnInit(): void {
    this.fecha = this.data?.newDateDuration;
  }

  public formUpdaterDueDateMinute = new FormGroup({
    dueDate: new FormControl(),
  });

  onDateChange(event: any) {
    this.fecha1 = event.target.value;
    this.setForm();
  }

  private setForm() {
    this.formUpdaterDueDateMinute.patchValue({
      dueDate: this.fecha1
    });
  }

  public submit() {
    const { dueDate } = this.formUpdaterDueDateMinute.value;

    if(dueDate <= this.data?.newDateDuration)
    {
      Swal.fire({
        title: 'Fecha Invalida',
        text: 'La fecha es anterior a la inicial',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar'
      });
    }
    else if(dueDate == null)
    {
      Swal.fire({
        title: 'Fecha Invalida',
        text: 'La fecha igual a la inicial',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar'
      });
    }
    else{
      this.request.minuteRequestId = this.data?.minuteRequestId;
      this.request.newDateDuration = dueDate; 
      this.serviceMinuta.updateDuration(this.data?.minuteRequestId,this.request).subscribe({
        next:(result) => {
          Swal.fire({
            title: 'Exitoso',
            text: 'La fecha de expiracion ha cambiado',
            icon: 'success',
            showConfirmButton: true,
            confirmButtonText: 'Cerrar'
          });
        },
        error:(err) => {
          console.log("Error en la peticion");
        }
      });
    }
  }

}
